export const NO_VALUE = '–';
